import { useEffect, useState } from "react";
import Sidebar from "../AdminComp/Sidebar";
import BreadCrumb from "../AdminComp/BreadCrumb";
import AdminBookingNavbar from "./AdminBookingNavbar";
import { Eye } from "react-feather";
import { baseurl } from "../../../component/Baseurl";
import axios from "axios";
import DataTable from "react-data-table-component";
import * as XLSX from "xlsx";

function AdminMobileRechargeReport() {
  const [mobileRecharges, setMobileRecharges] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  // Fetch Mobile Recharge data
  const fetchMobileRecharges = async () => {
    try {
      const response = await axios.get(`${baseurl}getAllMobileRecharges`);
      console.log("API Response:", response.data);

      if (response.data.data) {
        setMobileRecharges(response.data.data);
      } else {
        setMobileRecharges([]);
      }
    } catch (error) {
      console.error("Error fetching Mobile recharge data:", error);
      setError("Failed to load Mobile recharge report.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMobileRecharges();
  }, []);

  // Export data to Excel
  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(mobileRecharges);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Mobile Recharges");
    XLSX.writeFile(workbook, "Mobile_Recharge_Report.xlsx");
  };

  // Open modal with selected row data
  const openModal = (row) => {
    setSelectedRow(row);
    const modal = new window.bootstrap.Modal(document.getElementById("detailsModal"));
    modal.show();
  };

  // Define table columns
  const columns = [
    { name: "#", selector: (row, index) => index + 1, sortable: true, width: "60px" },
    { name: "Request ID", selector: (row) => row.request_id, sortable: true },
    { name: "Mobile", selector: (row) => row.mobile, sortable: true },
    { name: "Operator", selector: (row) => row.operator, sortable: true },
    { name: "Amount", selector: (row) => `₹ ${row.amount}`, sortable: true },
    { name: "Commission", selector: (row) => `₹ ${row.commission}`, sortable: true },
    {
      name: "Status",
      selector: (row) => row.txn_status,
      cell: (row) => (
        <span
          className={`badge ${row.txn_status === "SUCCESS" ? "bg-success" : "bg-danger"}`}
        >
          {row.txn_status}
        </span>
      ),
      sortable: true,
    },
    { name: "Date", selector: (row) => new Date(row.created_at).toLocaleDateString(), sortable: true },
    {
      name: "Action",
      cell: (row) => (
        <span className="btn btn-primary btn-sm" title="View Details" onClick={() => openModal(row)}>
          <Eye size={15} />
        </span>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  return (
    <>
      <div className="App" style={{ display: "flex" }}>
        <Sidebar />

        {/* Content area */}
        <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
          <BreadCrumb />
          <div className="container-fluid">
            <AdminBookingNavbar />

            <div className="crdmain mb-2">
              <div className="d-flex justify-content-between align-items-center">
                <h2 className="chart-title mb-0">Mobile Recharge Report</h2>
                <button className="btn btn-success ms-auto" onClick={exportToExcel}>
                  Download Excel
                </button>
              </div>

              {/* Show loading or error */}
              {loading && <p>Loading Mobile recharge report...</p>}
              {error && <p className="text-danger">{error}</p>}

              {!loading && !error && (
                <div className="row g-2 mt-0 mb-0">
                  <div className="col-md-12 p-2">
                    {/* DataTable */}
                    <DataTable
                      columns={columns}
                      data={mobileRecharges}
                      pagination
                      highlightOnHover
                      striped
                      responsive
                      defaultSortFieldId={1}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Bootstrap 5 Modal */}
      <div className="modal fade" id="detailsModal" tabIndex="-1" aria-labelledby="detailsModalLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="detailsModalLabel">Transaction Details</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              {selectedRow ? (
                <ul className="list-group text-start">
                  <li className="list-group-item"><strong>Request ID:</strong> {selectedRow.request_id}</li>
                  <li className="list-group-item"><strong>Mobile:</strong> {selectedRow.mobile}</li>
                  <li className="list-group-item"><strong>Operator:</strong> {selectedRow.operator}</li>
                  <li className="list-group-item"><strong>Amount:</strong> ₹ {selectedRow.amount}</li>
                  <li className="list-group-item"><strong>Commission:</strong> ₹ {selectedRow.commission}</li>
                  <li className="list-group-item"><strong>Status:</strong> {selectedRow.txn_status}</li>
                  <li className="list-group-item"><strong>Transaction Desc:</strong> {selectedRow.txn_desc}</li>
                  <li className="list-group-item"><strong>Opid:</strong> {selectedRow.opid}</li>
                  <li className="list-group-item"><strong>Vendor Txnid:</strong> {selectedRow.vendor_txnid}</li>
                  <li className="list-group-item"><strong>Txnid:</strong> {selectedRow.txnid}</li>
                  <li className="list-group-item"><strong>TDS :</strong> {selectedRow.tds}</li>
                  <li className="list-group-item"><strong>Total Charge :</strong> {selectedRow.totalcharge}</li>
                  <li className="list-group-item"><strong>Total CCF :</strong> {selectedRow.totalccf}</li>
                  <li className="list-group-item"><strong>Transaction Amount :</strong> {selectedRow.trasamt}</li>
                  <li className="list-group-item"><strong>Charged Amount :</strong> {selectedRow.chargedamt}</li>
                  <li className="list-group-item"><strong>Date:</strong> {new Date(selectedRow.created_at).toLocaleDateString()}</li>
                </ul>
              ) : (
                <p>No details available</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdminMobileRechargeReport;
